function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f9c4ba;}.b{fill:#fc2a00;}.c{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x2: 1,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fc2a00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f9c4ba"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1 -1)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M48.468,18A19.489,19.489,0,0,0,29,37.468c0,10.491,17.917,27.6,18.68,28.315a1.145,1.145,0,0,0,1.576,0c.763-.717,18.68-17.824,18.68-28.315A19.489,19.489,0,0,0,48.468,18Zm0,25.194a6.871,6.871,0,1,1,6.871-6.871A6.871,6.871,0,0,1,48.468,43.194Z",
  transform: "translate(4.065 2.468)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M14.742,1A13.757,13.757,0,0,0,1,14.742c0,7.382,12.446,18.695,12.975,19.173a1.145,1.145,0,0,0,1.535,0c.529-.479,12.975-11.792,12.975-19.173A13.757,13.757,0,0,0,14.742,1Zm0,18.323a4.581,4.581,0,1,1,4.581-4.581A4.581,4.581,0,0,1,14.742,19.323Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M31.468,56.613A19.489,19.489,0,0,1,12,37.145a1.145,1.145,0,0,1,2.29,0A17.2,17.2,0,0,0,31.468,54.323a1.145,1.145,0,0,1,0,2.29Z",
  transform: "translate(1.597 5.081)"
}));

var SvgDistance = function SvgDistance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 67.565,
    viewBox: "0 0 71 67.565",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDistance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/distance.968fe535.svg";
export { ForwardRef as ReactComponent };